module.exports = __webpack_public_path__ + "static/media/google-play-badge.f8c6c0cf.png";